<template>
  <div v-if="lot" class="ta-confirmation-lot-details">
    <div class="ta-lot-details-image">
      <b-img v-if="lot.image_urls.length" :src="lot.image_urls[0]"
             :alt="$options.filters.stripTags($options.filters.currentLocale(lot.title))"
             fluid
             thumbnail/>
      <b-img v-else src="https://cdn.artisio.co/no_image.jpg" fluid thumbnail/>
    </div>
    <h5 class="ta-lot-details-title" v-html="$options.filters.stripTags($options.filters.currentLocale(lot.title))">
    </h5>
  </div>
</template>

<script>

export default {
  name: "LotDetails",
  mixins: [],
  props: {
    lot: {
      required: true,
      type: Object
    }
  }
}
</script>

<style lang="scss" scoped>
.ta-confirmation-lot-details {
  display: flex;
  margin-bottom: 1rem;
  align-items: center;
  gap: 1rem;
  .ta-lot-details-image {
    width: 80px;
  }
  .ta-lot-details-title {
    flex: 1;
  }
}
</style>
